import { Link } from "react-router-dom";
import { brandStats, siteInfo } from "@/mocks/content";

export default function BrandIntro() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative rounded-lg overflow-hidden h-72 md:h-[420px] order-2 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=minimal%20elegant%20brand%20studio%20scene%20with%20neutral%20fabric%20draped%20over%20a%20wooden%20frame%20and%20a%20ceramic%20vessel%2C%20warm%20natural%20daylight%2C%20soft%20beige%20tones%2C%20refined%20artistic%20photography%2C%20calm%20composition&width=1000&height=1200&seq=home-brand-intro&orientation=portrait"
              alt="白峰美羽品牌美学"
              title="白峰美羽品牌简介 - 东方审美与现代工艺"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-700 mb-3">
              ABOUT BRAND
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading leading-snug">
              好的设计应当后退一步
              <br />
              让生活成为主角
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              {siteInfo.intro}
              从材质的选择到比例的推敲，从产品的打磨到空间的营造，白峰美羽始终相信：真正的品质感来自长期耐心，而不是一次性的惊艳。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mt-9">
              {brandStats.map((stat) => (
                <div key={stat.label}>
                  <p className="text-2xl md:text-3xl font-heading font-semibold text-primary-600">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-9 inline-flex items-center px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              认识白峰美羽
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}